module.exports = __webpack_public_path__ + "img/header-engagementRings100Carat.478f6a9.jpg";